import styled from "styled-components";

export const Division = styled.div`
  background-color: #e0e0e0;
  margin: .5rem 0;
  height: 1px;
`;

export const Radios = styled.div`
  display: flex;
  gap: 10px;
  max-width: 100%;
  flex-wrap: wrap;
`;

export const RadiosImage = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
`;